import styled from 'styled-components';

export const StyledUserPanelPreferences = styled.div`
    width: 100%;
    height: 100%;
`;
